import React from 'react';
import Keyboard from '../../../../../../quick-pick/maitland-keyboard';

class MaitLand extends React.Component {
  constructor(props) {
    super(props);

    this.hide = this.hide.bind(this);
  }

  hide() {
    this.props.hide(true);
  }

  render() {
    return <Keyboard onClick={this.props.onClick} close={this.hide} />;
  }
}

export default MaitLand;
